/* iPhone Walls — shared behaviour */
(function(){
  /* film grain + mesh blooms injected on every page */
  if(!document.querySelector('.grain')){const g=document.createElement('div');g.className='grain';document.body.appendChild(g)}
  const mesh=document.querySelector('.aurora');
  if(mesh)while(mesh.children.length<4)mesh.appendChild(document.createElement('i'));

  /* cursor-reactive glass: pointer highlight + micro tilt (fine pointers only) */
  if(matchMedia('(hover:hover) and (pointer:fine)').matches&&!matchMedia('(prefers-reduced-motion:reduce)').matches){
    document.querySelectorAll('[data-tilt]').forEach(el=>{
      const max=el.dataset.tilt==='soft'?3:6;
      el.addEventListener('pointermove',e=>{
        const r=el.getBoundingClientRect();
        const px=(e.clientX-r.left)/r.width,py=(e.clientY-r.top)/r.height;
        el.style.setProperty('--mx',(px*100).toFixed(1)+'%');
        el.style.setProperty('--my',(py*100).toFixed(1)+'%');
        el.style.transform='perspective(900px) rotateY('+((px-.5)*max).toFixed(2)+'deg) rotateX('+((.5-py)*max).toFixed(2)+'deg)';
        el.style.transition='transform .12s linear';
        el.classList.add('lit');
      });
      el.addEventListener('pointerleave',()=>{el.style.transition='transform .5s cubic-bezier(.2,.7,.2,1)';el.style.transform='';el.classList.remove('lit')});
    });
  }

  /* mobile sheet */
  /* A position:fixed element is trapped by any ancestor with transform, filter,
     backdrop-filter, perspective, will-change or contain - the site header has
     backdrop-filter, so re-parent the drawer to <body> before it is opened. */
  (function(){const sh=document.querySelector('.sheet');
    if(sh&&sh.parentElement!==document.body)document.body.appendChild(sh);})();
  document.addEventListener('click',e=>{
    if(e.target.closest('.burger')){document.querySelector('.sheet').classList.add('open');document.body.style.overflow='hidden'}
    if(e.target.closest('.sheet-x')||e.target.closest('.sheet a')){document.querySelector('.sheet').classList.remove('open');document.body.style.overflow=''}
  });

  /* mark active nav link */
  const here=location.pathname.split('/').pop()||'index.html';
  document.querySelectorAll('.links a,.sheet a.l').forEach(a=>{if(a.getAttribute('href')===here)a.classList.add('on')});

  /* countdown — any [data-cd] block with b#cd-d/h/m/s */
  const cd=document.querySelector('[data-cd]');
  if(cd){
    const key='iw_sale_end';
    let end=+localStorage.getItem(key);
    if(!end||end<Date.now()){end=Date.now()+(2*86400+14*3600+37*60+11)*1000;localStorage.setItem(key,end)}
    const g=id=>cd.querySelector('#'+id);
    const p=n=>String(n).padStart(2,'0');
    (function tick(){
      let s=Math.max(0,Math.floor((end-Date.now())/1000));
      const d=Math.floor(s/86400);s%=86400;const h=Math.floor(s/3600);s%=3600;const m=Math.floor(s/60);s%=60;
      if(g('cd-d'))g('cd-d').textContent=p(d);g('cd-h').textContent=p(h);g('cd-m').textContent=p(m);g('cd-s').textContent=p(s);
      setTimeout(tick,1000);
    })();
  }

  /* copy code */
  document.querySelectorAll('[data-copy]').forEach(b=>b.addEventListener('click',function(){
    const c=this.dataset.copy;
    if(navigator.clipboard)navigator.clipboard.writeText(c);
    const t=this.textContent;this.textContent='Copied ✓';
    setTimeout(()=>{this.textContent=t},1700);
  }));

  /* sticky buy bar */
  const bar=document.querySelector('.sticky');
  if(bar){
    const trig=document.querySelector('[data-sticky-after]')||document.querySelector('h1');
    const check=()=>{const r=trig.getBoundingClientRect();bar.classList.toggle('show',r.bottom<window.innerHeight*.45)};
    window.addEventListener('scroll',check,{passive:true});check();
  }


  /* fade-in on scroll — additive, never leaves content hidden */
  const rise=[...document.querySelectorAll('[data-rise]')];
  const reveal=el=>{el.style.opacity=1;el.style.transform='none'};
  const revealAll=()=>rise.forEach(reveal);
  rise.forEach(el=>{el.style.opacity=0;el.style.transform='translateY(14px)';el.style.transition='opacity .7s ease,transform .7s cubic-bezier(.2,.7,.2,1)'});
  let pending=rise.slice();
  const sweep=()=>{
    pending=pending.filter(el=>{
      const r=el.getBoundingClientRect();
      if(r.top<window.innerHeight-40&&r.bottom>0){reveal(el);return false}
      return true;
    });
    if(!pending.length)window.removeEventListener('scroll',sweep);
  };
  window.addEventListener('scroll',sweep,{passive:true});
  window.addEventListener('resize',sweep);
  sweep();
  setTimeout(sweep,400);
  setTimeout(revealAll,4000);
})();
